module.exports = __webpack_public_path__ + "img/slide1.89978f00.jpg";